import { FeatureSectionType } from "../../components/types";

export const cardConfig = [
  {
    title: "Clarity every step of the way",
    description:
      "Track every DME delivery and know when things will be delivered. Drill down into the specific contents of each package.",
    src: "/landing_page_assets/rive/20.riv",
    fallbackSrc: "/landing_page_assets/providers_page/img1.png",
    className: "",
    imageClassName: "tw-aspect-[684/513]",
  },
  {
    title: "Real-time coverage validation",
    description:
      "Eliminate the post-order back and forth for DME. Verse validates orders upon submission against payor reimbursement rules.",
    src: "/landing_page_assets/rive/21.riv",
    fallbackSrc: "/landing_page_assets/providers_page/img2.png",
    className: "min440:tw-h-full min440:tw-flex-col-reverse ",
    imageClassName: "tw-aspect-[684/513]",
  },
];

export const featureSections: FeatureSectionType[] = [
  {
    src: "",
    fallbackSrc: "/landing_page_assets/AIExtraction.png",
    title: "AI-driven medical record extraction & validation",
    description: [
      "Providers are stuck filling out order forms & double-entering information from their EMR. ",
      "Verse can use the medical record to automatically start a DME order with prefilled diagnostic & order item information. Providers can then review & submit.",
    ],
    features: [],
    hasButton: false,
    imageClassName: "tw-w-full tw-h-full tw-aspect-square",
  },
];
